import { z } from "zod";
import { CompositionConfigLight } from "../../../types";
import { ScrollingProfilesV1Props } from "./types";

const ScrollingProfilesV1Config: CompositionConfigLight<ScrollingProfilesV1Props> = {
	name: "ScrollingProfilesV1",
	assertValidProps: (props) => {
		return z
			.object({
				profiles: z.array(
					z.object({
						profilePictureUrl: z.string(),
						text: z.string(),
					}),
				),
				imageUrls: z.array(z.string()),
				title: z.string(),
				superTitle: z.string().optional(),
			})
			.parse(props) satisfies ScrollingProfilesV1Props;
	},
	videoConfig: {
		numFrames: (props) => Math.max(300, 30 * props.imageUrls.length),
		width: 1080,
		height: 1920,
	},
};

export default ScrollingProfilesV1Config;
